import React, { useState } from 'react';

export const WhyTherapyCardFirst = ({ Icon, flag, title, description, hoverBlock, hoverIcon }) => {
    const [hover, setHover] = useState(false);

    return (
        <div
            className="why-therapy-first-card-wrapper"
            style={hover ? hoverBlock : {}}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <div className="why-therapy-first-card-header">
                <div
                    className="why-therapy-first-card-icon-block"
                    style={{
                        background: hover ? hoverIcon.background : '',
                        borderColor: hover ? hoverIcon.borderColor : '',
                        transition: 'all 0.2s',
                    }}
                >
                    <Icon
                        className="why-therapy-first-card-icon"
                        style={{
                            filter: hover ? hoverIcon.filter : '',
                            transition: 'all 0.2s',
                        }}
                    />
                </div>

                {flag && <div className="why-therapy-first-card-flag">{flag}</div>}
            </div>

            <h4 className="why-therapy-first-card-title">{title}</h4>

            <p className="why-therapy-first-card-description">{description}</p>
        </div>
    );
};
